<template>
  <div class="wrap container">
    <div class="business-coop">
      <div class="title">
        <h2>商务合作</h2>
        <p>Business cooperation</p>
      </div>
      <div class="logo-list">
        <div class="logo-item" v-for="(item, index) in logoList" :key="index">
          <img :src="item.imgUrl" :alt="item.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallForBidsInfo",
  data() {
    return {
      logoList: [
        {
          name: "中国平安",
          imgUrl: require("@/assets/img/cooperation/pingan.png"),
        },
        {
          name: "中国人寿",
          imgUrl: require("@/assets/img/cooperation/china-life.png"),
        },
        {
          name: "中国大地保险",
          imgUrl: require("@/assets/img/cooperation/china-continent.png"),
        },
        {
          name: "中国太平",
          imgUrl: require("@/assets/img/cooperation/taiping.png"),
        },
        {
          name: "永安财险",
          imgUrl: require("@/assets/img/cooperation/yongan.png"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background-color: #f3f2f2;
}
.business-coop {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;

  .title {
    text-align: left;
    margin-bottom: 30px;

    h2 {
      font-size: 20px;
      color: #333;
      margin-bottom: 4px;
      font-weight: 500;
    }

    p {
      font-size: 14px;
      color: #999;
    }
  }

  .logo-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;

    .logo-item {
      width: 180px;
      height: 120px;
      border: 1px solid #eee;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      transition: all 0.3s;
      background-color: #fff;

      &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      }

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      &:nth-child(1) {
        img {
          width: 135px;
          height: auto;
        }
      }
    }
  }
}
</style>
